import { render, staticRenderFns } from "./UnitDetails.vue?vue&type=template&id=2af0253a&scoped=true&"
import script from "./UnitDetails.vue?vue&type=script&lang=js&"
export * from "./UnitDetails.vue?vue&type=script&lang=js&"
import style0 from "./UnitDetails.vue?vue&type=style&index=0&id=2af0253a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af0253a",
  null
  
)

export default component.exports